import React from "react";

import "./spinnerLoading.scss";
import LoadingSpin from "src/components/loadingSpin/loadingSpin";

//Para cambiar el tamaño del spinner, entregar propiedad de afterWidth="cantidad de pixeles deseado" y afterHeight="cantidad de pixeles deseado"
//Ojalá ambas propiedades tomen el mismo valor, para que quede circular y no ovalado.

export default function SpinnerLoading({
  content,
  width,
  height,
  afterWidth,
  afterHeight,
  colorSpinner,
  display,
  justifyContent,
}) {

  return <LoadingSpin content={content} />



  return (
    <div className="container-box">
      <div className="box" style={{ height, width, display, justifyContent }}>
        <div
          className="spinner-component spinner-component-1"
          style={{
            "--colorSpinner": colorSpinner || "#0099ff",
            "--afterWidth": afterWidth || "100px",
            "--afterHeight": afterHeight || "100px",
          }}
        ></div>
      </div>
      <span className="textLoading">{content}</span>
    </div>
  );
}
